import { Butticon } from '@hopin-team/ui-butticon';
import { Flex } from '@hopin-team/ui-flex';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { Pill } from '@hopin-team/ui-pill';
import { Text } from '@hopin-team/ui-text';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { BREAKPOINT_LARGE_WIDTH } from '../../constants';

export const stripes = (color1: string, color2: string) => css`
  background-image: repeating-linear-gradient(
    60deg,
    ${color1},
    ${color1} 16px,
    ${color2} 16px,
    ${color2} 18px
  );
`;

export const CustomSegmentIcon = styled.img`
  max-width: ${rem(22)};
  max-height: ${rem(13)};
  width: auto;
  height: auto;
  margin-right: ${rem(8)};
`;

export const Title = styled(Text)<{ subTitle?: boolean }>`
  color: var(--color-schedule-title);
  font-size: ${({ subTitle }) => rem(subTitle ? 12 : 14)};

  ${({ subTitle }) =>
    subTitle &&
    css`
      font-weight: 500;
    `};
`;

export const TimeSplitter = styled.span`
  margin: 0 ${rem(4)};
`;

export const DayIncrement = styled(Text)`
  font-size: ${rem(13)};
`;

export const EmptyText = styled(Text)`
  text-align: center;
  max-width: ${rem(288)};
`;

export const Description = styled(Text)`
  color: var(--color-schedule-description);
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  white-space: pre-line;
`;

export const FullFlex = styled(Flex)`
  width: 100%;
`;

export const Row = styled(FullFlex)`
  width: 100%;

  :not(:last-child) {
    border-bottom: 1px solid
      ${({ theme }) => getFromTheme('COLOR.GREY.300', theme)};
  }
`;

export const DescriptionContainer = styled(Flex)`
  width: 100%;
  max-width: ${`${BREAKPOINT_LARGE_WIDTH}px`};
`;

export const Speakers = styled(Flex)`
  width: 100%;
  max-width: ${`${BREAKPOINT_LARGE_WIDTH}px`};
`;

export const MoreSpeakersButton = styled.button`
  margin-bottom: ${rem(12)};
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => getFromTheme('COLOR.THEME.PRIMARY', theme)};
  justify-self: left;
`;

export const TagsContainer = styled(Flex)`
  max-width: 100%;
  flex-wrap: wrap;
`;

export const Link = styled(Butticon)`
  border-bottom: none;
`;

export const LiveTag = styled(Pill)`
  color: ${({ theme }) => getFromTheme('COLOR.GREY.WHITE', theme)};
  background-color: ${({ theme }) => getFromTheme('COLOR.RED.600', theme)};
  font-weight: 500;
  border: 0;
  width: min-content;
`;

export const EndedTag = styled(Pill)`
  color: ${({ theme }) => getFromTheme('COLOR.GREY.700', theme)};
  background-color: ${({ theme }) => getFromTheme('COLOR.GREY.200', theme)};
  font-weight: 500;
  border: 0;
  width: min-content;
`;

export const RenderAsHTML = styled.div`
  blockquote {
    overflow: hidden;
    padding-right: 1.5em;
    padding-left: 1.5em;
    margin-left: 0;
    margin-right: 0;
    font-style: italic;
    border-left: 5px solid #ccc;
  }
  blockquote[dir='rtl'] {
    border-right: 5px solid #ccc;
  }

  ul,
  ol {
    padding-left: 1rem;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
  }
`;

export const RecommendedPill = styled(Pill)`
  color: ${({ theme }) => getFromTheme(`COLOR.YELLOW.500`, theme)};
  background-color: ${({ theme }) => getFromTheme(`COLOR.YELLOW.100`, theme)};
  font-weight: 500;
  border: 0;
  width: min-content;
`;

export const SpeakerContainer = styled.div<{ link?: boolean }>`
  cursor: ${({ link }) => (link ? 'pointer' : 'auto')};
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${rem(32)};
  margin-right: ${rem(16)};
`;
